export default __webpack_public_path__ + "static/media/map.aeef5b68.png";